import { loadRuntimeConfig } from './config/runtimeConfig';
import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import ErrorPage from './components/error/ErrorPage';

async function bootstrap(): Promise<void> {
  try {
    const config = await loadRuntimeConfig();
    // Import the app only after configuration is ready: API slices and version
    // labels can read it as soon as their modules are evaluated.
    await import('./index');

    const script = document.createElement('script');
    script.src = config.VITE_INTEGRATION_CONFIG;
    script.async = true;
    script.onerror = () => console.error('Unable to load the integration SDK');
    document.head.appendChild(script);
  } catch (error) {
    console.error('Application startup failed', error);
    const container = document.getElementById('loading-container');
    if (container) {
      container.replaceChildren();
      createRoot(container).render(createElement(ErrorPage, {
        isLoadingError: true,
        message: 'We couldn’t load your application settings. Check your connection and try again.',
        onReload: () => window.location.reload(),
      }));
    }
  }
}

void bootstrap();
